<template>
  <span>
    <!-- {{definicionCampos}} -->
    <!-- {{cabeceras}} -->
    <!-- {{registros}} -->
    <!-- {{registrosSeleccionados}} -->

    <v-data-table
      :headers="cabeceras"
      :items="registrosNoBorrados"
      :options.sync="opcionesTabla"
      :server-items-length="totalRegistrosSinPaginar"
      :loading="cargando"
      :class="classDataTable"
      :footer-props="{'items-per-page-options': opcionesFilasPorPagina() }"
      :disable-filtering="modoMemoria"
      :disable-sort="modoMemoria"
      :hide-default-footer="modoMemoria"
      @dblclick:row="dobleClickFila"
      @click:row="clickFila"
      v-bind="$attrs"
      v-model="registrosSeleccionados"
    >
      <!-- titulo -->
      <template v-if="titulo" v-slot:top>
        <v-toolbar dense flat color="#b0b0c0">
          <v-toolbar-title>
              <v-icon v-if="icono" class="mt-n1 mr-1">{{icono}}</v-icon>
              {{titulo}}
          </v-toolbar-title>
          <v-btn
            small
            rounded
            color="primary"
            v-if="permitirAnadir"
            dark
            class="ml-4 mr-2"
            @click="anadirRegistro"
          >
            <v-icon small>mdi-plus</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-if="busquedaRapida && !modoMemoria"
            v-model="cadenaABuscar"
            @keyup="iniciarTemporizadorBusqueda"
            @click:clear="iniciarTemporizadorBusqueda"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            clearable
            :background-color="cadenaABuscar ? '#F4F4A0' : ''"
          ></v-text-field>
        </v-toolbar>

        <slot name="debajo-titulo" />
      </template>
      
      <!-- pasamos los slots especificados en TablaDatosAPI -->
      <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope"><slot :name="slot" v-bind="scope"/></template>

      <!-- botones de accion de registros -->
      <template v-slot:item.__acciones="{ item }">
        <v-icon v-if="permitirModificar" small color="primary" class="mr-2" @click="editarRegistro (item)">mdi-pencil</v-icon>
        <v-icon v-if="permitirEliminar" small color="primary" @click="eliminarRegistro (item)">mdi-delete</v-icon> <!-- color="#E06060" -->
      </template>

      <!-- boton de añadir en modo compacto o para cuando "modoMemoria = true" -->
      <template v-if="(!titulo && permitirAnadir) || modoMemoria" v-slot:footer>
        <v-divider />
        <v-row no-gutters>
          <v-spacer />
          <v-btn v-if="!titulo && permitirAnadir"
            :small="$attrs.dense"
            rounded
            color="#8080FF"
            dark
            text
            class="my-1"
            @click="anadirRegistro"
          >
            <v-icon small class="mr-1">mdi-plus</v-icon>Añadir
          </v-btn>
          <v-spacer />
          <div v-if="modoMemoria" class="text-caption pa-2 mr-5">
              Total filas: {{registrosNoBorrados.length}}
          </div>
        </v-row>
      </template>

    </v-data-table>

  
    <FormularioDatosAPI ref="formulario" :icono="icono" v-bind="formularioDatosApiProps">
       <template v-slot:default="{ definicionCampos, datosRegistro, accionCrud, esAccionEliminar }">
        <slot :definicionCampos="definicionCampos" :datosRegistro="datosRegistro" :accionCrud="accionCrud" :esAccionEliminar="esAccionEliminar"></slot>
       </template>
    </FormularioDatosAPI>
   


  </span>
</template>

<script>
import { DateTime } from "luxon";
import api from "@/api";
import FormularioDatosAPI from "@/components/FormularioDatosAPI-tabs.vue";
import CONSTANTES_CRUD from "@/constantesCRUD"

export default {
  components: { FormularioDatosAPI },
  props: {
    titulo: String,
    icono: String,
    tablaVista: {
      type: String,
      required: true,
    },
    camposTabla: Array,
    ordenInicial: String,
    filtroRegistros: String,
    variables: Object,
    sinSombra: Boolean,
    busquedaRapida: Boolean,
    permitirAnadir: Boolean,
    permitirModificar: Boolean,
    permitirEliminar: Boolean,
    tituloCrud: {
      type: String,
      default: "registro",
    },
    filasPorPagina: {
      type: Number,
      default: 10,
    },
    modoMemoria: {
      type: Boolean,
      default: false,
    },
    segundosAutoRefresco: {
      type: Number,
      default: 0,
    },
    formularioDatosApiProps: Object,
    eventoAntesProcesarRespuestaServidor: Function,
    eventoAntesAbrirFormularioDatos: Function,
    eventoAntesGuardarFormularioDatos: Function,
    eventoDespuesGuardarFormularioDatos: Function,
  },
  data() {
    this.idIntervalo = null;
    return {
      opcionesTabla: { page: 1, itemsPerPage: this.filasPorPagina, sortBy: [], sortDesc: [] },
      cadenaABuscar: "",
      temporizadorBusqueda: null,
      cabeceras: [],
      cargando: false,
      definicionCampos: {},
      registros: [],
      totalRegistrosSinPaginar: 0,
      registrosSeleccionados: [],
      formulario: null,
    };
  },
  computed: {
    classDataTable () {
      if (!this.sinSombra)
        return "elevation-4";
      else
        return "";
    },
    registrosNoBorrados () {
      return this.registros.filter (registro => registro ['!!'] != CONSTANTES_CRUD.ACCION.DELETE );
    }
  },
  methods: {
    opcionesFilasPorPagina() {
      if (this.filasPorPagina == -1)
        return [-1]
      else
        return [5, 10, 15, 20, 25, 50, 100, 250, 500];
    },
    procedeVisualizarCampo (definicionCampo) {
      return definicionCampo.visibilidad ? definicionCampo.visibilidad.toUpperCase().includes('T') : true;
    },
    iniciarTemporizadorBusqueda() {
      if (this.temporizadorBusqueda) clearTimeout(this.temporizadorBusqueda);
      this.temporizadorBusqueda = setTimeout(this.actualizarDatos, 500);
    },
    limpiarSeleccion() {
            if (window.getSelection) {
        if (window.getSelection().empty) {  // Chrome
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {  // Firefox
          window.getSelection().removeAllRanges();
        }
      } else if (document.selection) {  // IE?
        document.selection.empty();
      }
    },
    clickFila (item, row) {
      if (this.$attrs['item-key'])
        row.select(!row.isSelected);
    },
    dobleClickFila (mouseEvent, datos) {
      if (this.permitirModificar) {
        this.limpiarSeleccion();
        this.editarRegistro (datos.item);
      }
    },
    opcionesConsultaTablaVista() {
      let opciones = {};
      opciones._orden = "";
      if (!this.modoMemoria && this.filasPorPagina > 0) {
        // calculamos el registro inicial (_offset) dado el nº de pagina y nº de registros por pagina
        opciones._offset = (this.opcionesTabla.page - 1) * this.opcionesTabla.itemsPerPage;
        // indicamos el nº de registros por pagina
        opciones._limit = this.opcionesTabla.itemsPerPage;
        // indicamos la cadena de búsqueda rapida
        if (this.cadenaABuscar != "")
          opciones._busqueda = this.cadenaABuscar;
        // establecemos el orden de la consulta de acuerdo con "opcionesTabla.sortBy" y "opcionesTabla.sortDesc"
        this.opcionesTabla.sortBy.forEach((campo, indiceCampo) => {
          opciones._orden += campo.replace ("__VT", "");
          if (this.opcionesTabla.sortDesc[indiceCampo])
            opciones._orden += " DESC";
          opciones._orden += "\r\n";
        });
      }
      // si no se ha especificado un orden, establecemos el orden "inicial" indicado en el componente
      if ((opciones._orden == "") && this.ordenInicial)
        opciones._orden = this.ordenInicial;
      // limpiamos el parametro orden (si no hay, lo quitamos y si hay, los separamos por coma)
      if (opciones._orden == "")
        delete opciones._orden;
      else
        opciones._orden = opciones._orden.trim().replace("\r\n", ",");
      // indicamos un filtro (where) para la seleccion de registros
      if (this.filtroRegistros)
        opciones._filtro = this.filtroRegistros;
      // establecemos valores de variables para que puedan ser utilizadas en el back-end
      if (this.variables)
        opciones._variables = JSON.stringify (this.variables);

      return opciones;
    },
    claveRegistro (registro) {
      let clave = {};
      for (const nombreCampo in this.definicionCampos) {
        const campo = this.definicionCampos[nombreCampo];
        if (campo.es_clave == true && registro [nombreCampo] != undefined)
          clave [nombreCampo] = registro [nombreCampo];
      }
      if (Object.keys (clave).length > 0)
        return clave;
      else
        return null;
    },
    hayCambiosModoMemoria () {
      return this.registros.some ((registro) => {
        if (registro ['!!'] != undefined) return true;
      });
    },
    loteCambiosRegistros (callback){
      let lote = { insertar: [], actualizar: [], eliminar: [] };
      this.registros.forEach((registro) => {
        let copiaRegistro = {...registro};
        if (callback)
          callback (copiaRegistro);
        Object.keys (copiaRegistro).forEach ((campo) => {
          if (campo == "!!" || campo.toUpperCase().includes ("__VT"))
            delete copiaRegistro [campo];
        });
        if (registro ['!!'] == 'C')
          lote.insertar.push (copiaRegistro);
        else if (registro ['!!'] == 'U')
          lote.actualizar.push (copiaRegistro);
        else if (registro ['!!'] == 'D')
          lote.eliminar.push (copiaRegistro);
      });
      return lote;
    },

    complementarDatos () {
      // aplicamos dominios de valores (reemplazamos valores por sus correspondientes descripciones)
      // sobre el array de filas obtenido de la consulta
      for (const nombreCampo in this.definicionCampos) {
        const dc = this.definicionCampos [nombreCampo];

        let nombreCampoVT = nombreCampo; // nombre del campo que contendrá el "Valor Transformado"
        if (dc.dominio_valores != null) {
          nombreCampoVT += "__VT";
          this.registros.forEach((registro) => {
            this.$set (registro, nombreCampoVT, dc.dominio_valores[JSON.stringify (registro[nombreCampo] ? registro[nombreCampo] : null)]);
          });
        } else if (dc.tipo.toUpperCase().includes("DATETIME")) {
          nombreCampoVT += "__VT";
          this.registros.forEach((registro) => {
            if (registro [nombreCampo])
              this.$set (registro, nombreCampoVT, DateTime.fromSQL(registro [nombreCampo]).setLocale('es').toFormat("dd/MM/yyyy HH:mm"))
            else
              this.$set (registro, nombreCampoVT, '-');
          });
        } else if (dc.prefijo_valor || dc.sufijo_valor) {
          nombreCampoVT += "__VT";
          this.registros.forEach((registro) => {
            this.$set (registro, nombreCampoVT, (dc.prefijo_valor ? dc.prefijo_valor : '') + registro [nombreCampo] + (dc.sufijo_valor ? dc.sufijo_valor : ''));
          });
        }
        this.definicionCampos [nombreCampo].nombreCampoVT = nombreCampoVT;
      }
    },
    prepararCabeceras() {
      // creamos/actualizamos el array de opciones de cabecera de tabla segun la configuracion obtenida de la consulta
      this.cabeceras = [];
      for (const nombreCampo in this.definicionCampos) {
        const dc = this.definicionCampos[nombreCampo];
        if (!this.procedeVisualizarCampo (dc)) continue;
        if (this.camposTabla && this.camposTabla.length > 0)
          if (!this.camposTabla.includes (nombreCampo)) continue;

        let cabecera = {};
        cabecera.value = dc.nombreCampoVT;
        cabecera.text = dc.titulo;
        if (dc.alineacion != null) {
          if (dc.alineacion.toUpperCase().charAt(0) == "C")
            cabecera.align = "center";
          else if (dc.alineacion.toUpperCase().charAt(0) == "D")
            cabecera.align = "end";
        }
        this.cabeceras.push(cabecera);
      }
      // si se ha indicado, añadimos un a columna adicional para las acciones (modificar, eliminar)
      if (this.totalRegistrosSinPaginar > 0 && (this.permitirModificar || this.permitirEliminar)) {
        this.cabeceras.push({
          text: "Acciones",
          value: "__acciones",
          align: "center",
          sortable: false,
        });
      }
      //console.log (JSON.stringify (this.cabeceras));
    },
    actualizarDatos() {
      this.cargando = (this.segundosAutoRefresco == 0);
      api
        .obtenerRegistrosTablaVista(
          this.tablaVista,
          this.opcionesConsultaTablaVista()
        )
        .then((respuesta) => {
          if (this.eventoAntesProcesarRespuestaServidor)
            this.eventoAntesProcesarRespuestaServidor (respuesta.data.definicionCampos, respuesta.data.filas, respuesta.data.totalRegistrosSinPaginar);

          this.definicionCampos = respuesta.data.definicionCampos;
          this.registros = respuesta.data.filas; // volcamos la respuesta de la consulta a la variable reactiva del componente
          this.totalRegistrosSinPaginar = respuesta.data.totalFilasDisponibles;

          this.complementarDatos ();
          this.prepararCabeceras ();
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    antesCerrarFormularioDatos(formularioDatos, cancelado) {
      if (!cancelado && !this.modoMemoria)
        this.actualizarDatos();
      return true;
    },
    autoRefrescar(){
      if (!this.formulario.visible)
        this.actualizarDatos(true);
    },

    //----------------- C R E A T E
    anadirRegistro() {
      let nuevoRegistro = {};
      this.formulario.mostrar (CONSTANTES_CRUD.ACCION.CREATE,
                                `Añadir ${this.tituloCrud}`,
                                this.definicionCampos,
                                nuevoRegistro,
                                {
                                antesAbrir: this.eventoAntesAbrirFormularioDatos,
                                antesGuardar: this.eventoAntesGuardarFormularioDatos,
                                despuesGuardar: this.eventoDespuesGuardarFormularioDatos,
                                antesCerrarFormulario: this.antesCerrarFormularioDatos,
                                botonAccion: this.accionInsertarRegistro,
                                });
    },
    async accionInsertarRegistro (formularioDatos, arrayCambiosEnRegistro) {
      if (this.modoMemoria) {
        arrayCambiosEnRegistro ['!!'] = CONSTANTES_CRUD.ACCION.CREATE;
        this.registros.push (arrayCambiosEnRegistro);
        this.totalRegistrosSinPaginar++;

        this.complementarDatos ();
        this.prepararCabeceras ();
      } else if (Object.entries (arrayCambiosEnRegistro).length > 0) {
        await api.anadirRegistroTablaVista (this.tablaVista, arrayCambiosEnRegistro)
              .then ((respuesta) => {
                formularioDatos.datosRegistro [respuesta.data.campo_id] = respuesta.data.id_registro_insertado;
              });
      }
      this.$emit ('cambios', this.hayCambiosModoMemoria());
      return true;
    },

    //----------------- U P D A T E
    editarRegistro(registro) {
      this.formulario.mostrar (CONSTANTES_CRUD.ACCION.UPDATE,
                                `Editar ${this.tituloCrud}`,
                                this.definicionCampos,
                                registro,
                                {
                                antesAbrir: this.eventoAntesAbrirFormularioDatos,
                                antesGuardar: this.eventoAntesGuardarFormularioDatos,
                                despuesGuardar: this.eventoDespuesGuardarFormularioDatos,
                                antesCerrarFormulario: this.antesCerrarFormularioDatos,
                                botonAccion: this.accionEditarRegistro,
                                });
    },
    async accionEditarRegistro (formularioDatos, arrayCambiosEnRegistro) {
      if (this.modoMemoria) {
        Object.entries (arrayCambiosEnRegistro).forEach( ([nombreCampo, valor]) => {
          formularioDatos.registroOriginal [nombreCampo] = valor;
        });
        if (formularioDatos.registroOriginal ['!!'] != CONSTANTES_CRUD.ACCION.CREATE)
          this.$set (formularioDatos.registroOriginal, '!!', CONSTANTES_CRUD.ACCION.UPDATE);

        this.complementarDatos ();
      } else if (Object.entries (arrayCambiosEnRegistro).length > 0) {
        await api.modificarRegistroTablaVista (this.tablaVista, arrayCambiosEnRegistro, this.claveRegistro (formularioDatos.copiaDatosRegistro))
          .then (() => {
            //
          });
      }
      this.$emit ('cambios', this.hayCambiosModoMemoria());
      return true;
    },

    //----------------- D E L E T E
    eliminarRegistro(registro) {
      this.formulario.mostrar (CONSTANTES_CRUD.ACCION.DELETE,
                                `Eliminar ${this.tituloCrud}`,
                                this.definicionCampos,
                                registro,
                                {
                                antesAbrir: this.eventoAntesAbrirFormularioDatos,
                                botonAccion: this.accionEliminarRegistro,
                                antesCerrarFormulario: this.antesCerrarFormularioDatos,
                                });
    },
    async accionEliminarRegistro (formularioDatos) {
      if (this.modoMemoria) {
        if (formularioDatos.registroOriginal ['!!'] == CONSTANTES_CRUD.ACCION.CREATE) {
          let indice = this.registros.indexOf (formularioDatos.registroOriginal);
          this.registros.splice (indice, 1);
        } else {
          this.$set (formularioDatos.registroOriginal, '!!', CONSTANTES_CRUD.ACCION.DELETE);
        }
        this.totalRegistrosSinPaginar--;
        this.prepararCabeceras ();
      } else {
        await api.eliminarRegistroTablaVista (this.tablaVista, this.claveRegistro (formularioDatos.copiaDatosRegistro))
          .then (() => {
            //
          });
      }
      this.$emit ('cambios', this.hayCambiosModoMemoria());
      return true;
    }
  },
  watch: {
    opcionesTabla: {
      handler() {
        this.actualizarDatos();
      },
    },
    registrosSeleccionados: {
      handler () {
        this.$emit ("seleccionModificada", this.registrosSeleccionados);
      }
    }
  },
  beforeMount() {
    if (!this.modoMemoria)
      window.addEventListener ("focus", this.actualizarDatos);

    if (this.segundosAutoRefresco > 0)
       this.idIntervalo = setInterval (this.autoRefrescar, this.segundosAutoRefresco * 1000);
  },
  beforeDestroy() {
    if (!this.modoMemoria)
      window.removeEventListener ("focus", this.actualizarDatos);

    if (this.idIntervalo)
      clearInterval (this.idIntervalo);
  },
  mounted() {
    this.formulario = this.$refs ['formulario'];
    this.$emit ("montado", this);
  }
};
</script>

<style>
.v-data-table thead {
  background-color: #e4e4f4;
}
tr.v-data-table__selected {
  background:#b1bdf9 !important;
}
</style>